<template>
  <div>
    <label class="label eligibility_label">Become an affiliate in 60 seconds</label>
    <div id="name_container">
      <Input
        @enter="next"
        :inputField="inputs.first_name"
        inputName="First Name"
        inputType="name"
        autocomplete="given-name"
      />
      <Input
        @enter="next"
        :inputField="inputs.last_name"
        inputName="Last Name"
        inputType="name"
        autocomplete="family-name"
      />
    </div>
    <Input
        @enter="next"
        :inputField="inputs.company"
        inputName="Legal Business Name"
        inputType="name"
        :icons="{ right: 'fa-solid fa-briefcase' }"
    />
    <AddressInput
        :inputField="inputs.address"
        inputName="Address"
        inputType="string"
        @selectedAddress="updateAddress"
      />
    <i
        v-show="selected_address == true"
        class="address_selected fas fa-check"
    ></i
    >&nbsp;
    <i
        v-show="selected_address == false"
        class="address_selected"
    >
    <svg xmlns="http://www.w3.org/2000/svg" width="11" height="14" viewBox="0 0 11 14" fill="none">
        <path d="M5.69565 13C5.69565 13 10.3913 8.82609 10.3913 5.69565C10.3913 3.10231 8.28899 1 5.69565 1C3.10232 1 1 3.10231 1 5.69565C1 8.82609 5.69565 13 5.69565 13Z" stroke="#999999"/>
        <path d="M7.19585 5.5001C7.19585 6.32852 6.52427 7.0001 5.69585 7.0001C4.86742 7.0001 4.19584 6.32852 4.19584 5.5001C4.19584 4.67167 4.86742 4.0001 5.69585 4.0001C6.52427 4.0001 7.19585 4.67167 7.19585 5.5001Z" stroke="#999999"/>
    </svg>
    </i>&nbsp; <label class="label full_address">{{ full_address }}</label>&nbsp;
    <a class="toggle_address" href="javascript:void(0)" @click="toggleAddressFields" role="button">
    Or enter address manually
    </a>
    <Input
        @enter="next"
        :inputField="inputs.city"
        inputName="City"
        inputType="string"
        ref="city"
        autocomplete="address-level2"
        v-show="show_address_fields == true"
    />
    <div id="state_container" v-show="show_address_fields == true">
    <Input
        @enter="next"
        :inputField="inputs.state"
        inputName="State"
        inputType="state"
        ref="state"
        autocomplete="address-level1"
        v-show="show_address_fields == true"
    />
    <Input
        @enter="next"
        :inputField="inputs.zip"
        inputName="Zip Code"
        inputType="zip"
        ref="zip"
        autocomplete="postal-code"
        v-show="show_address_fields == true"
    />
    </div>
    <Input
      @enter="next"
      :inputField="inputs.email"
      inputName="Email Address"
      inputType="email"
      :icons="{ right: 'fa-envelope' }"
    />
    <Input
      @enter="next"
      :inputField="inputs.phone"
      inputName="Cell Phone"
      inputType="phone"
      :icons="{ right: 'fa-mobile-alt' }"
      ref="phone"
    />
    <!-- <div id="checkbox_sms">
      <Checkbox
        :inputField="inputs.smsOptIn"
        inputName="SMS Optin"
        inputType=""
      >
        By checking this box, you agree to receive <b>application status and funding decision notifications</b> along with recurring automated 
        promotional and personalized marketing text messages(e.g. AI content) from Cardiff and partners at the number you provide.
        Consent is not a condition of any purchase. 
        Reply HELP for help and STOP to cancel. Msg frequency varies. Msg & data rates may apply. 
        View <a href="https://attnl.tv/t/3Rk" target="_blank">Terms</a> & <a href="https://attnl.tv/p/3Rk" target="_blank">Privacy</a>.
      </Checkbox>
    </div> -->
    <div class="buttons is-right" @click="handleBlur" style="margin-bottom: 0;">
      <a class="button is-link padded-button next-button continue-button" @click="next">
        Continue
      </a>
    </div>
    <label class="label" id="agree_label">
      By clicking Continue you agree to the <a href="/application-agreement/" target="_blank">
        Cardiff Application Agreement
      </a>
      and
      <a href="/e-sign-consent/" target="_blank">
        E-Sign Consent Agreement 
      </a>.
    </label>
  </div>
</template>

<script>
import Vue from "vue";
import Input from "@/components/shared/Input";
// import Checkbox from "@/components/shared/Checkbox";
import ApplyPage from "@/components/shared/ApplyPage";
import AddressInput from "@/components/shared/AddressInput";
import MyUtils from "@/utils/MyUtils";
import $ from "jquery";

export default {
  name: "AffiliatesBasic",
  components: {
    Input,
    // Checkbox,
    AddressInput
  },
  mixins: [ApplyPage],
  props: {
    phone: String,
    email: String,
  },
  created: function () {
   console.log('created basic');
  },
  data() {
    return {
      obj: "affiliate",
      inputs: {
        first_name: Input.model(),
        last_name: Input.model(),
        email: Input.model(this.email),
        phone: Input.model(),
        company: Input.model(),
        address: AddressInput.model(),
        city: Input.model(),
        state: Input.model(),
        zip: Input.model(),
        // smsConsent: Input.model(),
        // smsOptIn: Input.model(),
      },
      show_address_fields: true,
      selected_address: false,
      full_address: "Please type and select your business address",
    };
  },
  methods: {
    handleBlur: function () {
      console.log("focus out");
    },
    updateAddress: function (data) {
      console.log("update address");
      console.log(data);
      this.inputs.city.value = data.city;
      this.inputs.state.value = data.state;
      this.inputs.zip.value = data.zip;
      if (
        data.city &&
        data.city !== "" &&
        data.state &&
        data.state !== "" &&
        data.zip &&
        data.zip !== ""
      ) {
        console.log('changing..')
        this.show_address_fields = false;
        this.selected_address = true;
        this.full_address =
          data.street_number +
          " " +
          data.street +
          ", " +
          data.city +
          ", " +
          data.state +
          ", " +
          data.zip;
      }
    },
    toggleAddressFields: function () {
      this.show_address_fields = !this.show_address_fields;
    },
  },
  mounted: function () {
    console.log('mounted');
    let email = MyUtils.getWithExpiry('email');
    console.log('email storage:');
    console.log(email);
    this.inputs.email.value = email;
    let phone = MyUtils.getWithExpiry('phone');
    this.inputs.phone.value = phone;
    console.log('phone storage:');
    console.log(phone);

    let firstname = MyUtils.getWithExpiry('firstname');
    this.inputs.first_name.value = firstname;

    let lastname = MyUtils.getWithExpiry('lastname');
    this.inputs.last_name.value = lastname;

    this.show_address_fields = false;
    //@todo pass this validation inside the component
    let self = this;
    $("#map").focusout(function () {
      // console.log("selected address", self.selected_address);
      if (self.selected_address === false) {
        self.show_address_fields = true;
      }
    });
    console.log(self.inputs.phone);

    // self.inputs.phone.value = phone;

    if(self.inputs.phone.value !== ''){
        setTimeout(function(){
         $('#18').click();
         let cleaned = ('' + self.inputs.phone.value).replace(/\D/g, '');

        // Extract area code, first 3 digits, and last 4 digits
        let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
            console.log(match)
        if (match) {
            self.inputs.phone.value = `(${match[1]}) ${match[2]}-${match[3]}`;
        }
        },2000)
        
    }
  },
  watch: {
    inputs: {
      deep: true,
      handler(newValue, oldvalue) {

      },
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.eligibility_label{
  margin-bottom: 22px;
  font-weight: bold;
  color: #000;
  font-family: Roboto;
  font-size: 1.2rem;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 0.2px;
}
#name_container{
  display: inline-flex;
  width: 100%;
}
#name_container div{
  width: 50%;
  margin-right: 10px;
}
.full_address {
  color: gray;
  display: inline-block;
  margin-bottom: 10px;
}
@media (max-width: 80em) {
  .full_address {
    margin-bottom: 0px;
  }
  .toggle_address {
    margin-bottom: 10px;
    display: inline-block;
  }
}
@media (max-width: 47.999em) {
  .full_address {
    margin-bottom: 0px;
  }
  .toggle_address {
    margin-bottom: 10px;
    display: inline-block;
  }
}
</style>